import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";

import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import "./PartnerApp.css";
import PartnerFeatures from "./PartnerFeatures";
import PartnerBenefits from "./PartnerBenefits";
// Component for displaying Partner App details
export default function PartnerApp() {
  // Key service descriptions
  const data1 = [
    "Registry Stack: GBR Network offers a range of registry stack, including Identity and Access Management (IAM) for secure user authentication and access control, Registration Services for seamless account creation and management, and Content & Services for efficient content distribution and service delivery. They also provide Enterprise Asset Management (EAM) for asset optimization, Microservices for scalable backend functionality, Proxy Services for routing requests, and customizable Portals for user interactions, enhancing platform flexibility and user experience.",
    "Blockchain: GBR Network’s Blockchain Services include the Enterprise Activation Server, which securely manages and activates blockchain-related activities, the Blockchain Network Client, allowing seamless interaction with the blockchain network, and the Blockchain Proxy Server, serving as an intermediary to facilitate communication and transactions within the blockchain ecosystem. These services ensure secure, transparent, and efficient blockchain integration for various business needs.",
  ];

  const data2 = [
    "AgriCloud Stack : GBR Network offers a AgriCloud stack solution, which includes a Standard Gateway for routing and managing traffic, a Broker for message handling and communication between services, and a Service Endpoint (SEP) that provides secure access to backend services. These components work together to ensure seamless integration, efficient data flow, and secure connections across the network, enhancing the overall performance and flexibility of cloud-based applications.",
    "Device Management: Device Management is a service provided by GBR Network that enables seamless monitoring, control, and management of IoT devices across various environments. It ensures secure connectivity, real-time updates, and efficient lifecycle management for devices, enhancing operational performance and reliability.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="agriinput-marketplace-bg"
        bannerTitle={["Partner App"]}
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="PartnerApp" />

      {/* Overview Features Section */}
      <Container>
        <OverviewFeatures data1={data1} data2={data2} />
      </Container>

      {/* Features Sections */}
      <PartnerFeatures />
      {/* Benefits Sections */}
      <PartnerBenefits />
    </>
  );
}
